export const ACTION_SUCCESS = 'success'
export const ACTION_ERROR = 'error'
export const TO_ROUTE = 'toRoute'



// WEBPACK FOOTER //
// ./src/store/mutations.js